import './sass/main.scss';
import './partials/js/helpers/wiki2html';
import './partials/js/helpers/jquery-isOnScreen';
import './partials/js/helper';
import './partials/js/interface';
import './partials/js/htmlOnly';
import './partials/js/event';
import './partials/js/ui';
import './partials/js/analytics';
import './partials/js/store';
import './partials/js/screening';
import './partials/js/constants';
import './partials/js/surveyState';

// flat is load is successful
Pollfish.success = true;

// check if stylesheets are loaded
if (window.loadStylesheets === false) {
  Pollfish.success = false;
}

// init only if all libs are loaded
if (Pollfish.success) {
  // wait for everything else to load including images and then alert SDK
  $(window).load(() => {
    // Runs the function that populates Pollfish.* object with data coming from the server
    // where applicable
    Pollfish.initApi();

    // Default texts to english. Fixes issues where the getFromServer failed
    // and we didn't know which language to select.
    Pollfish.ui.texts = Pollfish.ui.getFallbackText();

    // document init is now asynchronous where it was synchronous in SDK < 19
    Pollfish.helper.document.init(() => {
      // We did not add the document.int as a callback to this render function
      // because Pollfish.helper.json is not filled with data yet
      Pollfish.helper.window.init();
    });
  });
}
